import { Button, Icon } from "material-ui";
import Media from "react-media";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import { newTheme } from "../constants";
import React from "react";

const styles = {
  icon: {
    marginRight: 5,
  },
};

export default ({ to, icon, caption, hashLink, style }) => {
  const LinkToUse = hashLink ? HashLink : Link;
  return (
    <LinkToUse style={{ textDecoration: "none" }} to={to}>
      <Media query="(min-width: 900px) and (max-width: 1199px)">
        <Button
          style={{ color: newTheme.palette.primary[500], ...style }}
          title={caption || undefined}
          compact
        >
          <Icon>{icon}</Icon>
        </Button>
      </Media>
      <Media query="(min-width: 1200px)">
        <Button
          style={{ color: newTheme.palette.primary[500], ...style }}
          title={caption || undefined}
        >
          <Icon style={styles.icon}>{icon}</Icon>
          {caption}
        </Button>
      </Media>
    </LinkToUse>
  );
};



// WEBPACK FOOTER //
// ./src/core/components/NavLink.js